import React, { Component, Fragment } from "react";

import { inject, observer } from "mobx-react";

import { Grid, Switch, Button, Card, Avatar, IconButton, TextField, InputLabel, Typography } from "@material-ui/core";
import BusinessIcon from "@material-ui/icons/Business";

import CardHeader from "@material-ui/core/CardHeader";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import ModalContainer from "../../modal/ModalContainer";
import ProfileSearchBoxWithGoogleSearch from "../../fields/ProfileSearchBoxWithGoogleSearch";
import RichTextEditor from "../../richTextEditor/RichTextEditor";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { ProfileType } from "../../../types/enum";
import blankProfile from "../../../img/hotgig-loading.png"
import ClearIcon from "@material-ui/icons/Clear";
import GooglePlaceAutoComplete2 from "../../../components/maps/GooglePlaceAutocomplete2";
import { GoogleMap, Marker, withScriptjs, withGoogleMap } from "react-google-maps";
import { Label } from "react-bootstrap";


const GoogleMaps = withScriptjs(
    withGoogleMap(props => (
        <GoogleMap
            defaultZoom={16}
            defaultCenter={{ lat: props.latitude, lng: props.longitude }}
            center={{
                lat: props.latitude,
                lng: props.longitude
            }}
        >
            {props.isMarkerShown && <Marker position={{ lat: props.latitude, lng: props.longitude }} />}
        </GoogleMap>
    ))
);
@inject("agentVenueStore", "profileStore", "templateStore", "userInvitationStore","generalProfileStore")
@observer
class VenueInvitationModal extends Component {
    constructor(props) {
        super(props);
        this.myTextRef = React.createRef();
        this.googlePlaces = "";
    }
    state = {
        inviteNewUser: false,
        isExist: false,
        isExpand: false
    };
    initMap = () => {
        let map = new google.maps.Map(document.createElement("div"));
        this.googlePlaces = new google.maps.places.PlacesService(map);
    }
    componentDidMount() {
        window.initMap = this.initMap
        const gmapScriptEl = document.createElement(`script`)
        gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAP_KEY}&libraries=places&callback=initMap`
        document.querySelector(`body`).insertAdjacentElement(`beforeend`, gmapScriptEl)
        this.props.agentVenueStore.resetInvitationField();
        

    }
   

    onClose = () => {
        this.props.agentVenueStore.resetInvitationField();
        this.props.userInvitationStore.resetInvitedData();
        this.props.generalProfileStore.reset();
        
        this.props.onClose()
        this.setState({...this.state, inviteNewUser: false, isExist:false})
    };

    searchAgain = () => {
        this.props.agentVenueStore.resetInvitationField();
        this.props.userInvitationStore.resetInvitedData();
        this.props.generalProfileStore.reset();
        
        this.setState({...this.state, inviteNewUser: false, isExist:false})
    }

    renderDaySwitch = () => {
        return (
            <Grid container spacing={0}>
                {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(data => (
                    <Grid item xs={3} md={12} key={data + "-day"}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.props.agentVenueStore.dayToBookVenueInvitation[data.toLowerCase()]}
                                    onChange={() => this.props.agentVenueStore.toggleDayToBookVenueInvitational(data.toLowerCase())}
                                    value={data.toLowerCase()}
                                    color="primary"
                                />
                            }
                            label={data}
                        />
                    </Grid>
                ))}
            </Grid>
        );
    };
    handleInvite = () => {
        const { invitedUserFirstName, invitedUserLastName, invitedUserEmail, errors } = this.props.userInvitationStore;
        const { searchedAddress,longitude,latitude, street,
            city,
            postal,
            state,venueWebsite,venuePhone,venueName,venuePhoto,
            countryCode,placeId,tradingHours } = this.props.generalProfileStore;
            
        var currentProfile = this.props.profileStore.currentProfile;
        this.props.templateStore.showLoadingScreen();
        var data = {
            venueName: venueName,
            firstName: invitedUserFirstName,
            lastName: invitedUserLastName,
            email: invitedUserEmail,
            venuePhone: venuePhone,
            venueWebsite: venueWebsite,
            state: state,
            countryCode: countryCode,
            postal: postal,
            city: city,
            street: street,
            longitude: longitude,
            latitude: latitude,
            placeId: placeId,
            createdById: currentProfile?.id,
            tradingHours: JSON.stringify(tradingHours)
        }

        this.props.userInvitationStore.createVenueExternalInvitation(data,venuePhoto).then((result) => {
            this.props.agentVenueStore.resetAgentVenues()
                this.props.agentVenueStore.getMyVenueRosterV2(currentProfile.id,20,1).then(() => {
                    this.props.agentVenueStore.resetInvitationField();
                    this.props.generalProfileStore.reset();
                    this.onClose()
                    this.props.templateStore.openSnackbar("Venue has been added.");
                    this.props.templateStore.hideLoadingScreen();
                    this.setState({...this.state, inviteNewUser: false})
                    localStorage.setItem(`resetAgentVenueRoster`, true);
                })
        }).catch((err) => {
            if(this.props.agentVenueStore.invitedProfile){
                this.setState({...this.state, inviteNewUser: false})
            }
            
            this.props.templateStore.openSnackbar(err);
            this.props.templateStore.hideLoadingScreen();
        })
        
    }
    requestAccess = () => {
        const { inviteNewUser } = this.state;

        this.props.templateStore.showLoadingScreen();

        if (inviteNewUser) {
            this.props.userInvitationStore.inviteVenueOwnerByAgent().then(
                () => {
                    this.props.agentVenueStore.getAgentVenueRequest().then(() => {
                        this.props.templateStore.openSnackbar("Venue has been invited.");
                        this.props.templateStore.hideLoadingScreen();
                        this.props.agentVenueStore.resetInvitationField();
                        this.setState({...this.state, inviteNewUser: false})
                        this.onClose()
                    })
                },
                err => {
                    this.props.templateStore.openSnackbar(err);
                    this.props.templateStore.hideLoadingScreen();
                }
            );
        } else {
            this.props.agentVenueStore.inviteVenueByAgentV2().then(response => {
                this.props.agentVenueStore.getAgentVenueRequest().then(() => {
                    this.props.templateStore.openSnackbar("Venue has been invited.");
                    this.props.templateStore.hideLoadingScreen();
                    this.props.agentVenueStore.resetInvitationField();
                    this.setState({...this.state, inviteNewUser: false})
                    this.onClose()
                })
            });
        }
    };

    handleChangeSearchAddress = value => {
        this.props.generalProfileStore.setSearchedAddress(value);
    };
    uuidv4 = () => {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
          (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
        );
    }
    getExcludeSearch = () => {
        const { pendingAgentVenues, agentVenues } = this.props.agentVenueStore;
        var excludedProfile = [];
        pendingAgentVenues.forEach(data => {
            if(data) {
                var venue = data.primaryProfile.type === ProfileType.Venue.ordinal ? data.primaryProfile : data.secondaryProfile;
                if (venue) {
                    excludedProfile.push(venue);
                }
            }
        });
        agentVenues.forEach(data => {
            if (data && data.venue) {
                excludedProfile.push(data.venue);
            }
        });

        return excludedProfile;
    };

    
    handleStreetChange = e => this.props.generalProfileStore.setStreet(e.target.value);
    handleCityChange = e => this.props.generalProfileStore.setCity(e.target.value);
    handlePostalChange = e => this.props.generalProfileStore.setPostal(e.target.value);
    handleStateChange = e => this.props.generalProfileStore.setState(e.target.value);
    handleCountryChange = value => this.props.generalProfileStore.setCountryCode(value);
    handleChangeLongitudeLatitude = value => {
        this.props.generalProfileStore.setLongitudeLatitude(value);
    };

    handleSearchPlaceId = (placeId,name,photosUrl) => {
        this.googlePlaces.getDetails({ placeId: placeId}, (place) => this.handleFunction(place,name,photosUrl));
    }

    handleFunction = (place,name,photosUrl) => {
        var isExpand = false
        var currentProfile = this.props.profileStore.currentProfile;
       this.props.userInvitationStore.getInvitationByAgentIdPlaceId(currentProfile?.id, place?.place_id).then((result) => {
        if(!result?.isExist){
            var tradingHours = []
            if(place?.website){
                var websiteArr = place.website.split("?")
                if(websiteArr.length){
                    if(websiteArr[0].length > 100){
                        isExpand = true
                    }
                    this.props.generalProfileStore.setWebsiteChange(websiteArr[0]);
                }else{
                    this.props.generalProfileStore.setWebsiteChange(place.website);
                }
            
            }else{
                this.props.generalProfileStore.setWebsiteChange("");
            }
            if(place?.place_id){
                this.props.generalProfileStore.setPlaceId(place?.place_id);
            }else{
                this.props.generalProfileStore.setPlaceId("");
            }
            if(place?.formatted_phone_number){
                this.props.generalProfileStore.setPhoneChange(place.formatted_phone_number);
            }else{
                this.props.generalProfileStore.setPhoneChange("");
            }
            if(place?.opening_hours && place?.opening_hours?.weekday_text?.length){
                var weekday_text = place?.opening_hours.weekday_text
                var number = 0
                weekday_text.forEach(item => {
                    number = number + 1
                    var itemArr = item.split(": ")
                    var day = itemArr[0]
                    var description = itemArr[1].replace(/\s/g, '')
                    let currentTime = new Date();
                    var obj = {id: currentTime.getTime()+number,day: day, hour: description}
                    tradingHours.push(obj)
                });
                this.props.generalProfileStore.setTradingHours(tradingHours);
            }else {
                this.props.generalProfileStore.setTradingHours([]);
            }
            
            this.props.generalProfileStore.setVenueNameChange(name);
            this.props.generalProfileStore.setPhotoChange(photosUrl);
            this.setState(
                {
                    ...this.state,
                    isExist: false,
                    isExpand: isExpand
                }
            )
            }else{
                if(result.webSite?.length > 100){
                    isExpand = true
                }
                this.props.agentVenueStore.setInvitedProfile(result.venue)
                this.setState(
                    {
                        ...this.state,
                        inviteNewUser: false,
                        isExist: true,
                        isExpand: isExpand
                    }
                )
            }
            
        })


    }

    handleNoVenueFound = value => {
        this.props.userInvitationStore.resetInvitedData();

        this.setState(
            {
                ...this.state,
                inviteNewUser: true,
                
            },
            () => {
                this.props.userInvitationStore.setInvitedVenueName(value);
                this.handleChangeSearchAddress(value)
                setTimeout(
                    () => this.myTextRef.current.fetchSuggestion(),
                    50
                  );
                
            }
        );
    };

    isInviteButtonDisabled = () => {
        const { inviteNewUser } = this.state;
        const { errors, invitedUserFirstName, invitedUserLastName, invitedUserEmail } = this.props.userInvitationStore;
        if (inviteNewUser) {
            const isError = errors?.firstName || errors?.lastName || errors?.actName || errors?.email
            return isError || !invitedUserFirstName || !invitedUserLastName || !invitedUserEmail;
        } else {
            return !this.props.agentVenueStore.invitedProfile;
        }
    };

    handleValidate(value, type) {
        switch (type) {
            case "firstName":
                this.props.userInvitationStore.validateInvitedUserFirstName(value);
                break;
            case "lastName":
                this.props.userInvitationStore.validateInvitedUserLastName(value);
                break;
            case "email":
                this.props.userInvitationStore.validateInvitedUserEmail(value);
                break;
        
            default:
                break;
        }
    }

    render() {
        const { inviteNewUser } = this.state;
        const avatarUlr = this.props.agentVenueStore.invitedProfile && this.props.agentVenueStore.invitedProfile.profileImage && this.props.agentVenueStore.invitedProfile.profileImage.url200 && this.props.agentVenueStore.invitedProfile.profileImage.url200 != "";
        const { invitedVenueName, invitedUserFirstName, invitedUserLastName, invitedUserEmail, errors } = this.props.userInvitationStore;
        const { searchedAddress,longitude,latitude, street,
            city,
            postal,
            state,venueWebsite,venuePhone,venueName,venuePhoto,
            countryCode } = this.props.generalProfileStore;
        
        return (
            <ModalContainer open={this.props.open} onClose={this.onClose}>
                <div style={{
                    backgroundColor: '#FE0D9D',
                    padding: '16px 20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                }}>
                    <BusinessIcon style={{ color: '#ffffff', fontSize: '24px' }} />
                    <Typography variant="h6" style={{ color: '#ffffff', fontSize: '18px', fontWeight: 500, margin: 0 }}>Add Venue</Typography>
                </div>
                <DialogContent
                    style={{
                        paddingTop: "16px"
                    }}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} lg={this.state.isExist ? 12 : 10}>
                            <Grid container spacing={8}>
                                <Grid item xs={12}>
                                    {this.props.agentVenueStore.invitedProfile && !inviteNewUser ? (
                                        // <Card>
                                        //     <CardHeader
                                        //      avatar={
                                        //         avatarUlr ?  (
                                        //             <Avatar
                                        //                 alt={this.props.agentVenueStore.invitedProfile.fullName}
                                        //                 src={this.props.agentVenueStore.invitedProfile.profileImage.url200}
                                        //                 style={{
                                        //                     width: 40,
                                        //                     height: 40
                                        //                 }}
                                        //             />
                                        //         ) : (
                                        //             <Avatar
                                        //                 style={{
                                        //                     width: 40,
                                        //                     height: 40
                                        //                 }}
                                        //                 src={blankProfile}
                                        //             />
                                                        
                                        //         )
                                        //     }
                                               
                                        //         action={
                                        //             <IconButton onClick={() => this.props.agentVenueStore.setInvitedProfile(undefined)}>
                                        //                 <ClearIcon />
                                        //             </IconButton>
                                        //         }
                                        //         title={this.props.agentVenueStore.invitedProfile.fullName}
                                        //     />
                                        // </Card>
                                         <Grid container className="style-venue">
                                         <Grid item md={1} xs={6}>
                                            {

                                                avatarUlr ?  (
                                                    <Avatar
                                                        alt={this.props.agentVenueStore.invitedProfile.fullName}
                                                        src={this.props.agentVenueStore.invitedProfile.profileImage.url200}
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            display: "block",
                                                            marginLeft: "auto",
                                                            marginRight: "auto",
                                                            marginTop:"55px"
                                                        }}
                                                    />
                                                ) : (
                                                    <Avatar
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            display: "block",
                                                            marginLeft: "auto",
                                                            marginRight: "auto",
                                                            marginTop:"55px"
                                                        }}
                                                        src={blankProfile}
                                                    />
                                                        
                                                )
                                            }
                                         </Grid>
                                         <Grid item md={5} xs={6}>
                                            <div class="container-vertical">
                                                <div className="vertical-center">
                                                    <div>
                                                    {this.props.agentVenueStore.invitedProfile.fullName}
                                                    </div>
                                                    <div>
                                                    {this.props.agentVenueStore.invitedProfile.street} 
                                                    </div>
                                                    <div>
                                                    {`${this.props.agentVenueStore.invitedProfile.city},${this.props.agentVenueStore.invitedProfile.state}, ${this.props.agentVenueStore.invitedProfile.postal}`}
                                                    </div>
                                                    <div>
                                                    {this.props.agentVenueStore.invitedProfile.contactPhone}
                                                    </div>
                                                    <div>
                                                    {this.props.agentVenueStore.invitedProfile.webSite}
                                                    </div>
                                                </div>
                                             </div>
                                         </Grid>
                                         <Grid item md={6} xs={12}>
                                             <GoogleMaps
                                                 isMarkerShown
                                                 googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAP_KEY}&libraries=places`}
                                                 loadingElement={<div style={{ height: `100%` }} />}
                                                 containerElement={<div style={{ height: this.state.isExpand ? '250px' : `150px` }} />}
                                                 mapElement={<div style={{ height: `100%` }} />}
                                                 longitude={Number(this.props.agentVenueStore.invitedProfile.longitude)}
                                                 latitude={Number(this.props.agentVenueStore.invitedProfile.latitude)}
                                             />
                                         </Grid>
                                        
                                     </Grid>
                                    ) : !inviteNewUser ? (
                                        <Fragment>
                                            <InputLabel>Venue</InputLabel>
                                            <ProfileSearchBoxWithGoogleSearch
                                                placeholder="Search Venue"
                                                handleSearch={value => this.props.profileStore.searchVenueProfile(value)}
                                                handleChange={item => this.props.agentVenueStore.setInvitedProfile(item)}
                                                exclude={this.getExcludeSearch()}
                                                handleEmpty={value => this.handleNoVenueFound(value)}
                                                menuStyle={{
                                                    position: "absolute",
                                                    maxHeight: "300px",
                                                    overflowY: "auto",
                                                    width: "100%"
                                                }}
                                            />
                                        </Fragment>
                                        
                                    ) : (
                                        <Grid container spacing={8}>
                                           
                                            {longitude && latitude ? (
                                                // venueName, street, city + state postal code, phone, website
                                            <Grid container className="style-venue">
                                                <Grid item md={1} xs={6}>
                                                {venuePhoto?.length ?  (
                                                    <Avatar
                                                        alt={venueName}
                                                        src={venuePhoto[0]}
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            display: "block",
                                                            marginLeft: "auto",
                                                            marginRight: "auto",
                                                            marginTop:"55px"
                                                        }}
                                                    />
                                                ) : (
                                                    <Avatar
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            display: "block",
                                                            marginLeft: "auto",
                                                            marginRight: "auto",
                                                            marginTop:"55px"
                                                        }}
                                                        src={blankProfile}
                                                    />
                                                        
                                                )
                                                    }
                                                </Grid>
                                                <Grid item md={5} xs={6}>
                                                    <div class="container-vertical">
                                                        <div className="vertical-center">
                                                            <div>
                                                            {venueName}
                                                            </div>
                                                            <div>
                                                            {street} 
                                                            </div>
                                                            <div>
                                                            {`${city},${state}, ${postal}`}
                                                            </div>
                                                            <div>
                                                            {venuePhone}
                                                            </div>
                                                            <div>
                                                            {venueWebsite}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item md={6} xs={12}>
                                                    <GoogleMaps
                                                        isMarkerShown
                                                        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAP_KEY}&libraries=places`}
                                                        loadingElement={<div style={{ height: `100%` }} />}
                                                        containerElement={<div style={{ height: this.state.isExpand ? '250px' : `150px` }} />}
                                                        mapElement={<div style={{ height: `100%` }} />}
                                                        longitude={Number(longitude)}
                                                        latitude={Number(latitude)}
                                                    />
                                                </Grid>
                                               
                                            </Grid>
                                            
                                ) : (
                                    ""
                                )}
                                {
                                    longitude && latitude ? (
                                        <Grid style={{marginTop:20}} container spacing={8}>
                                            <Grid item xs={12}>
                                                <Typography component="p">
                                                You can invite the venue manager to Hot Giggity which will allow them to view and promote all upcoming bookings.(Optional)
                                                </Typography>
                                            </Grid>
                                            
                                            <Grid item xs={12}>
                                                <TextField
                                                    label="Venue Manager First Name"
                                                    value={invitedUserFirstName}
                                                    fullWidth
                                                    onBlur={e => this.handleValidate(e.target.value, "firstName")}
                                                    onChange={e => this.props.userInvitationStore.setInvitedUserFirstName(e.target.value)}
                                                    error={errors && errors["firstName"] ? true : false}
                                                    helperText={errors && errors["firstName"] ? errors["firstName"] : ""}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    label="Venue Manager Last Name"
                                                    value={invitedUserLastName}
                                                    fullWidth
                                                    onBlur={e => this.handleValidate(e.target.value, "lastName")}
                                                    onChange={e => this.props.userInvitationStore.setInvitedUserLastName(e.target.value)}
                                                    error={errors && errors["lastName"] ? true : false}
                                                    helperText={errors && errors["lastName"] ? errors["lastName"] : ""}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    label="Venue Manager Email"
                                                    value={invitedUserEmail}
                                                    fullWidth
                                                    onBlur={e => this.handleValidate(e.target.value, "email")}
                                                    onChange={e => this.props.userInvitationStore.setInvitedUserEmail(e.target.value)}
                                                    error={errors && errors["email"] ? true : false}
                                                    helperText={errors && errors["email"] ? errors["email"] : ""}
                                                />
                                            </Grid>
                                        </Grid>
                                    ) :  <Grid item xs={12}>
                                    <GooglePlaceAutoComplete2
                                        ref={this.myTextRef}
                                        value={searchedAddress === 'null' ? "" : searchedAddress}
                                        label="Venue"
                                        placeholder="Type venue name or address"
                                        handleChange={this.handleChangeSearchAddress}
                                        getPlaceDetails={this.handleSearchPlaceId}
                                        handleChangeStreet={this.handleStreetChange}
                                        handleChangeCity={this.handleCityChange}
                                        handleChangePostal={this.handlePostalChange}
                                        handleChangeState={this.handleStateChange}
                                        handleChangeCountry={this.handleCountryChange}
                                        handleChangeLatLng={this.handleChangeLongitudeLatitude}
                                    />
                                </Grid>
                                }
                                        </Grid>   
                                    )}
                                </Grid>
                                { this.props.agentVenueStore.invitedProfile && !inviteNewUser && !this.state.isExist ?  <Grid item xs={12}>
                                        <Typography component="p" style={{marginTop:10}}>
                                        {venueName ? `${venueName}${city? ", "+city : ""}` : `${this.props.agentVenueStore.invitedProfile.fullName}${this.props.agentVenueStore.invitedProfile.city? ", "+this.props.agentVenueStore.invitedProfile.city : ""}`} exists in the Hot Giggity database. To request access, select the days you are requesting access to book, complete the Request Message field and click 'Request Access'. You will be notified if and when your request has been granted

                                        </Typography>
                                    </Grid> :
                                    this.state.isExist ?
                                    <Typography component="p" style={{marginTop:10}}>
                                        This venue already exists in your Agency Venue roster and can't be added again.  Would you like to search for another venue?
                                    </Typography>
                                    :
                                     null

                                }
                               
                                { this.props.agentVenueStore.invitedProfile && !inviteNewUser && !this.state.isExist ? <Grid item xs={12}>
                                    <InputLabel>Request Message</InputLabel>
                                    <RichTextEditor
                                        value={this.props.agentVenueStore.invitationMessage}
                                        onChange={value => this.props.agentVenueStore.setInvitationMessage(value)}
                                    />
                                </Grid> : null

                                }
                                
                            </Grid>
                        </Grid>
                        {
                            !this.state.isExist ?
                            <Grid item xs={12} lg={2}>
                                <InputLabel>Booking Days</InputLabel>
                                {this.renderDaySwitch()}
                                <Typography variant="caption">Select the days of the week you need access to book</Typography>
                            </Grid>
                        : null
                        }
                       
                    </Grid>
                </DialogContent>
                <DialogActions style={{ padding: '12px 20px 20px', gap: '12px' }}>
                    <Button 
                        onClick={this.onClose}
                        style={{
                            color: '#666',
                            textTransform: 'none',
                            fontWeight: 500
                        }}
                    >
                        Cancel
                    </Button>

                    {
                        this.props.agentVenueStore.invitedProfile && !inviteNewUser ? 
                        !this.state.isExist ?
                        <Button 
                            id="submit-invite-venue" 
                            variant='contained' 
                            onClick={this.requestAccess}
                            style={{
                                backgroundColor: '#FE0D9D',
                                color: '#ffffff',
                                textTransform: 'none',
                                fontWeight: 500,
                                padding: '8px 20px',
                                borderRadius: '6px'
                            }}
                        >
                            Request Access
                        </Button> :
                        <Button 
                            id="submit-invite-venue" 
                            variant='contained' 
                            onClick={this.searchAgain}
                            style={{
                                backgroundColor: '#FE0D9D',
                                color: '#ffffff',
                                textTransform: 'none',
                                fontWeight: 500,
                                padding: '8px 20px',
                                borderRadius: '6px'
                            }}
                        >
                            Search Again
                        </Button> 
                        : 
                        <Button 
                            id="submit-invite-venue" 
                            variant='contained' 
                            onClick={this.handleInvite}
                            style={{
                                backgroundColor: '#FE0D9D',
                                color: '#ffffff',
                                textTransform: 'none',
                                fontWeight: 500,
                                padding: '8px 20px',
                                borderRadius: '6px'
                            }}
                        >
                            Add Venue
                        </Button>
                    }
                    
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default VenueInvitationModal;
